import { makeStyles } from '@material-ui/core'

export const useStyle = makeStyles(() => ({
  mapWrapper: {
    position: 'relative',
  },
}))
